"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@material-ui/core/styles");
var _Autocomplete = _interopRequireDefault(require("@material-ui/lab/Autocomplete"));
var _SttInput = _interopRequireDefault(require("./SttInput"));
var _styles2 = _interopRequireDefault(require("./styles"));
var _SttSkeleton = _interopRequireDefault(require("../SttSkeleton"));
var _excluded = ["inputprops", "error", "carregando"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return (0, _styles2["default"])(theme);
});
function SttAutocomplete(props) {
  var classes = useStyles();
  var inputprops = props.inputprops,
    error = props.error,
    _props$carregando = props.carregando,
    carregando = _props$carregando === void 0 ? false : _props$carregando,
    other = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, carregando ? /*#__PURE__*/_react["default"].createElement(_SttSkeleton["default"], {
    variant: "rect",
    width: '100%'
  }, " ", /*#__PURE__*/_react["default"].createElement(_SttInput["default"], null), " ") : /*#__PURE__*/_react["default"].createElement(_Autocomplete["default"], _extends({
    noOptionsText: "Sem op\xE7oes dispon\xEDveis"
  }, other, {
    renderInput: function renderInput(params) {
      return /*#__PURE__*/_react["default"].createElement(_SttInput["default"], _extends({}, params, inputprops, {
        helperText: inputprops.error ? inputprops.error : "",
        error: inputprops.error ? true : false,
        variant: "outlined",
        margin: "dense",
        fullWidth: true,
        InputLabelProps: _objectSpread(_objectSpread({}, params.InputLabelProps), {}, {
          classes: {
            root: classes.label,
            focused: classes.focused,
            error: classes.error
          }
        }),
        InputProps: _objectSpread(_objectSpread({}, params.InputProps), {}, {
          classes: {
            root: classes.input,
            focused: classes.cssfocused,
            notchedOutline: classes.notchedOutline,
            disabled: classes.disabled,
            error: classes.error
          }
        })
      }));
    }
  })));
}
SttAutocomplete.propTypes = {
  inputprops: _propTypes["default"].object.isRequired
};
var _default = SttAutocomplete;
exports["default"] = _default;